import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Gallery from "./components/Gallery";
import Booking from "./components/Booking";
import Location from "./components/Location";
import Footer from "./components/Footer";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(
      "ErrorBoundary caught an error:",
      error,
      errorInfo.componentStack
    );
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              Something went wrong
            </h1>
            <p className="text-gray-600 mb-4">
              We're sorry, but something unexpected happened.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="btn btn-black"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const [currentPage, setCurrentPage] = React.useState("home");
  return (
    <div
      className="min-h-screen bg-gradient-to-br from-stone-50 to-orange-50 pt-24"
      data-name="app"
      data-file="app.js"
    >
      <Header currentPage={currentPage} setCurrentPage={setCurrentPage} />
      {currentPage === "home" && (
        <>
          <Hero />
          <About />
          <Gallery />
          <Booking />
        </>
      )}
      {currentPage === "about" && <About />}
      {currentPage === "gallery" && <Gallery />}
      {currentPage === "booking" && <Booking />}
      {currentPage === "location" && <Location />}
      <Footer setCurrentPage={setCurrentPage} />
    </div>
  );
}

export default function AppWithErrorBoundary() {
  return (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}
